import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContainerFreightOptionView } from '@core/proposals/freight-options';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-freight-options-table',
  templateUrl: './freight-options-table.component.html',
  styleUrls: ['./freight-options-table.component.scss'],
})
export class FreightOptionsTableComponent {
  @Input() options: any[] = [];
  @Input() selectedId: number | null = null;
  /**
   * Per-option container preview (capacity, per m3 contribution for this line, expiry). null keeps the plain
   * table used by the manual (non container) flow.
   */
  @Input() containerViews: ContainerFreightOptionView[] | null = null;
  /** i18n key that replaces the label of the pick button (for example "Alterar frete"). */
  @Input() pickLabelKey: string | null = null;
  @Output() select = new EventEmitter<any>();

  constructor(private readonly _translocoService: TranslocoService) {}

  get showContainerColumns(): boolean {
    return this.containerViews !== null;
  }

  view(row: any): ContainerFreightOptionView | null {
    return this.containerViews?.find((v) => v.freightId === row?.id) ?? null;
  }

  price(row: any): number {
    return row?.Pricing?.find((p: any) => p.isMainCurrency)?.value ?? 0;
  }

  currency(row: any): string {
    return row?.Pricing?.find((p: any) => p.isMainCurrency)?.currency?.name ?? 'EUR';
  }

  /** Prices of the freight in the other (non main) currencies, shown under the main price for reference. */
  otherPrices(row: any): any[] {
    return (row?.Pricing ?? []).filter((p: any) => !p.isMainCurrency && p.currency?.name);
  }

  via(row: any): string {
    const map: Record<string, string> = {
      SEA: this._translocoService.translate('proposals.freightOptionsTable.via.sea'),
      AIR: this._translocoService.translate('proposals.freightOptionsTable.via.air'),
      LAND: this._translocoService.translate('proposals.freightOptionsTable.via.land'),
    };
    return map[row?.via] ?? row?.via ?? '—';
  }

  trackByFreightId(_index: number, row: any): number {
    return row.id;
  }

  pick(row: any): void {
    this.select.emit(row);
  }
}
